export const USER_ERROR_MESSAGE_KEYWORD = 'User: ';
export const USER_OPTED_OUT_ERROR_MESSAGE = 'Message not sent: Candidate opted out of messaging.';
export const CANDIDATE_ALREADY_APPLIED_TO_JOB_ERROR_MESSAGE = 'Candidate already applied to job.';
